export default {
	id: "imac",
	title: "iMac",
	company: "Apple",
	styles: [
		{
			title: "normal",
			pos: ["5%", "4%", "34%", "4%"],
			colors: [
				{
					title: "Silver",
					hex: "#D5D2CF",
					img: require("./original/silver.png")
				}
			]
		},
		{
			title: "flat",
			pos: ["5%", "4%", "35%", "4%"],
			colors: [
				{title: "Silver", hex: "#D5D2CF", img: require("./flat/silver.svg")}
			]
		}
	]
};
